import { render, staticRenderFns } from "./WorkAuthorizationItem.vue?vue&type=template&id=02de6478&scoped=true&"
import script from "./WorkAuthorizationItem.vue?vue&type=script&lang=js&"
export * from "./WorkAuthorizationItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkAuthorizationItem.vue?vue&type=style&index=0&id=02de6478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de6478",
  null
  
)

export default component.exports